import {EventEmitter, Injectable, Output} from "@angular/core";
import {NgbModal, NgbModalConfig} from "@ng-bootstrap/ng-bootstrap";
import {InactivityModalComponent} from "../../../components/inactivity-modal/inactivity-modal.component";
import {AuthService} from "../auth/auth.service";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import jwt_decode from "jwt-decode";
import * as moment from "moment/moment";
import {LoadingService} from "../loading/loading.service";
import * as pubsub from 'pubsub-js';
import {PubsubEnum} from "../../enums/pubsub.enum";
@Injectable({providedIn: 'root'})
export class InactivityService {

    private modalRef: any;
    @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    private timeout: any;
    private readonly SESSION_TIMEOUT = 240000; //4 minutos
    private readonly LAST_ACTIVITY_KEY = 'ACT_USR_STATE';
    private broadcastChannel: BroadcastChannel;
    private pubSubInactivityModals: any;

    constructor(
        private modalService: NgbModal,
        private modalConfig: NgbModalConfig,
        private loadingService: LoadingService,
        private authService: AuthService) {
        modalConfig.backdrop = 'static';
        modalConfig.keyboard = false;
        this.initializeCommunication();
    }

    private initializeCommunication() {
        this.broadcastChannel = new BroadcastChannel('inactivity_channel');
        this.broadcastChannel.onmessage = (event) => {
            switch (event.data.type) {
                case 'activity':
                    this.reset();
                    break;
                case 'logout':
                    if (this.isDiscoveryWindow()) {
                        window.close();
                    }
                    this.cleanup();
                    this.authService.logOut();
                    break;
                case 'continue_session':
                    this.close();
                    this.reset();
                    break;
            }
        };
        this.pubSubInactivityModals = pubsub.subscribe(PubsubEnum.CLOSE_INACTIVITY_MODALS, () => {
            if (this.modalRef) {
                this.close();
                this.reset();
            }
        });
    }
    syncCloseModals() {
        pubsub.publish(PubsubEnum.CLOSE_INACTIVITY_MODALS, true);
        this.broadcastChannel.postMessage({ type: 'continue_session' });
    }


    open() {
        if (!this.modalRef) {
            this.modalRef = this.modalService.open(InactivityModalComponent);
        }
    }

    close() {
        if (this.modalRef) {
            this.modalRef.dismiss();
            this.modalRef = null;
            this.closeModalEvent.emit(true);
        }
    }

    startSessionTimer() {
        const jwtToken: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        const jwtDecoded: any = jwt_decode(jwtToken);
        if (!this.modalRef && jwtDecoded?.sitToken === 'VA') {
            clearTimeout(this.timeout);
            sessionStorage.setItem(this.LAST_ACTIVITY_KEY, Date.now().toString());
            this.timeout = setTimeout(() => {
                const jwtToken: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
                if (jwtToken) {
                    this.open();
                }
            }, this.SESSION_TIMEOUT);
        }
    }

    resetSessionTimer() {
        if (this.isNearExpireAccessToken() && !this.modalRef) {
            this.continueSession();
        }
        sessionStorage.setItem(this.LAST_ACTIVITY_KEY, Date.now().toString());
        this.broadcastChannel.postMessage({ type: 'activity' });
        this.reset();
    }

    reset() {
        clearTimeout(this.timeout);
        this.startSessionTimer();
    }

    private isNearExpireAccessToken(): any {
        const accessToken: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN);
        const tokenDecode: any = jwt_decode(accessToken);
        const expMoment = moment(tokenDecode.exp * 1000);
        const now = moment();
        const minutesDifference = moment.duration(expMoment.diff(now));
        return minutesDifference.asMilliseconds() <= 300000;
    }

    continueSession() {
        this.loadingService.show();
        this.authService.refreshToken(this.authService.getHeaders()).subscribe({
            next: tokens => {
                sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN, tokens.jwt);
                sessionStorage.setItem(StorageKeysEnum.REFRESH_TOKEN, tokens.refreshToken);
                sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN_WSO, tokens.wsoToken);
                sessionStorage.setItem(StorageKeysEnum.JWT_WSO_DECODE, JSON.stringify(jwt_decode(tokens.wsoToken)));
                this.loadingService.hide()
                this.close();
                this.reset();
                return
            },
            error: err => {
                this.loadingService.hide()
                this.close();
                console.log(err)
                return;
            }
        })
    }
    stopTimer() {
        this.broadcastChannel.postMessage({ type: 'logout' });
    }
    cleanup() {
        if (this.pubSubInactivityModals) {
            pubsub.unsubscribe(this.pubSubInactivityModals);
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        if (this.broadcastChannel) {
            this.broadcastChannel.close();
        }
    }
    private isDiscoveryWindow(): boolean {
        return window.opener !== null && window.name === 'DiscoverBankPage';
    }
    isModalOpen(): boolean {
        return !!this.modalRef;
    }
}
